module.exports = __webpack_public_path__ + "media/images/sunbasket_july4th/bg-lg-ed068363acbce717e7f819459126cac9.jpg";